<template>
    <section class="mb-l insu-desc-cards-wrapper container" v-if="type=='pet'" > 
        <Card
            class="insu-prod-card"
             v-for="item in bannerinfo[type].list"
             :key="item.id"             
             style="width:270px ;margin:5px"
          >
            <div
              slot="title"
              class="text-center"
            >
              <h3 class="main-title">{{ `${item.insuName}` }}</h3>
              <p class="premiums">{{ `${item.premiums} 元` }} </p>
            </div>
            <div >
                <h4 class="sub-title" >{{ item.type }}</h4>
                 <ul>
                  <li
                    v-for="(items, index) in item.content"
                    :key="index"
                    class="clearfix"
                  >
                    <span v-text="items.title" />
                    <span class="amount pull-right">{{ items.amount ? items.amount : '-' }}</span>
                  </li>
                </ul>
            </div>
      <div class="insu-prod-card-footer">     
        <Button 
          long
          size="large"        
          v-on:click="item.id = true"  
        >
          <Icon 
            type="eye"
            size="20"
          />更多細節
        </Button>      
      <Modal
      class-name="insu-prod-details-modal"
          v-model="item.id"
          :width="930"  
          scrollable       
      >
        <div class="clearfix mb-s insu-prod-premiums" >
                    <h3 class="main-title">{{ `${item.insuName}` }}</h3>
                   <div class="pull-right premiums-right">
                    <p class="premiums">{{ `${item.premiums} 元` }} </p>
                    </div>
                     </div>
                  <div class="insu-prod-details">
              <InsuProdDetailList 
                v-for="(data, i) in item.items"
                :key="i"
                :data="data"
              />
              <InsuProdPolicies :prodPolicies="item.prodPolicies" />
            </div>
              
              <div slot="footer">            
              </div> 
      </Modal>
      </div>
     </Card>  
    </section>  
  </template>

  <script>
  import { mapState, mapActions, mapMutations } from 'vuex';  
  import { Poptip ,Card,Modal, Button, Icon} from "iview";
  import InsuProdDetailList from '@/components/insurance/InsuProdDetailList';
  import InsuProdPolicies from '@/components/insurance/InsuProdPolicies';
  export default {
    components: { 
        Poptip,
        Card,
        Modal,
        Button, 
        Icon,
        InsuProdDetailList,
        InsuProdPolicies
    },
    props: {
      type: {
        type: String,
        default: null
      },
      data: {
        type: Object,
        default: null
      },
      value: {
        type: Boolean,
        default: false
      },
      },
    data(){
       return {
          modal1:false,
          modal2:false,
          modal3:false,
          modal4:false,
          modal5:false,
          modal6:false,
          bannerinfo:{
            pet:{
                list:[
                  { 
                    id:this.modal1,                   
                    insuName:'富邦產險 方案A',
                    premiums:'1090',
                    type:'投保年齡',
                      content:[{
                        title:'犬',
                        amount:'8週~9歲'
                        },
                        { title:'貓',
                        amount:'8週~11歲'}],                     
                      items:[{
                        type:'寵物醫療費用補償保險（限意外事故）',
                        items:[{ 
                        title:'保期內最高',
                        amount:'8,000',
                        desc:'被保險寵物在需要診療的狀況下，於獸醫診療機構接受一般門診治療之費用。對於每一事故實際載明於醫療費用單據上之門診費用，扣除約定之自負額，最高以門診費用保險金額為限。但保險期間內給付以 5 次事故為限。'
                       }]
                      },
                      {
                        type:'寵物意外喪葬費用保險（最高給付1次）',
                        items:[{
                          title:'保期內最高',
                          amount:'8,000',
                          desc:'被保險寵物因遭受意外傷害事故致死，就實際支出之寵物意外喪葬費用給付寵物意外喪葬費用保險金。 ※ 保險期間內賠償金額最高以保險單首頁上所載的「寵物意外喪葬費用保險金額」為限。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險（最高給付1次）',
                        items:[{
                          title:'保期內最高',
                          amount:'8,000',
                          desc:'被保險寵物遺失時，自發現遺失30 日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付寵物協尋廣告費用保險金。（不含因懸賞廣告給付之報酬） ※ 保險期間內給付以1 次事故為限，賠償金額以保險單首頁上所載的「寵物協尋廣告費用保險金額」為限。'
                        }]
                      },
                      {
                        type:'寵物侵權責任保險',
                        items:[{
                          title:'保期內最高',
                          amount:'10萬',
                          desc:'被保險人在保險期間內因被保險寵物之行為致第三人體傷、死亡或財物損害，依法 應負賠償責任而受賠償請求時，本公司對被保險人負賠償之責。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'富邦寵物險',
                        url:'https://ec.rockgp.com/PET/%E5%AF%8C%E9%82%A6%E7%94%A2%E7%89%A9%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA(%E8%A8%88%E7%95%AB%E4%B8%80).pdf'
                      }]
                   },
                  { 
                    id:this.modal2,                  
                    insuName:'富邦產險 方案B',
                    premiums:'3006',                    
                    type:'投保年齡',
                    content:[{
                        title:'犬',
                        amount:'8週~7歲'
                        },
                        { title:'貓',
                        amount:'8週~7歲'}],
                    items:[{
                        type:'寵物醫療費用補償保險（意外事故或疾病）',
                        items:[{
                          title:'門診費用每一事故最高（最高給付5次、自負額損失之20%）',
                          amount:'1,000',
                          desc:'對於每一被保險寵物每一事故實際載明於醫療費用單據上之門診費用，扣除本保險契約所約定之自負額，最高以保險單首頁所載寵物醫療費用補償項目之門診費用保險金額為限。但保險期間內給付以五次事故為限。'
                        },
                        {
                          title:'住院費用每一事故最高（最高給付2次、自負額損失之20%）',
                          amount:'5,000',
                          desc:'對於每一被保險寵物每一事故之損失，扣除本保險契約所約定之自負額，最高以保險單首頁所載寵物醫療費用補償項目之住院費用保險金額為限。但保險期間內給付以兩次事故為限。'
                        },
                        {
                          title:'手術費用每一事故最高（最高給付2次、自負額損失之20%）',
                          amount:'3萬',
                          desc:'被保險寵物以治療為目的，利用器具及麻醉將患部或必要部位切除或切開等行為所需之費用（含門診手術費用）。對於每一事故實際載明於醫療費用單據上之手術費用，扣除約定之自負額，最高以手術費用保險金額為限。但保險期間內給付以 2 次事故為限。'
                        },
                        {
                          title:'輸血費用定額給付（最高給付1次）',
                          amount:'800',
                          desc:'因疾病或意外傷害，經登記合格獸醫診療機構進行輸血治療時，另定額給付輸血費用補償保險金，但保險期間內給付以 1 次為限。'
                        },
                        {
                          title:'預防針過敏定額給付（最高給付1次）',
                          amount:'800',
                          desc:'因施打預防針所引起之過敏事故，另外定額給付預防針過敏補償保險金，但保險期間內給付以 1 次為限。'
                        }]
                      },                      
                      {
                        type:'寵物意外喪葬費用保險（最高給付1次）',
                        items:[{
                          title:'保期內最高',
                          amount:'8,000',
                          desc:'被保險寵物因遭受意外傷害事故致死，就實際支出之寵物意外喪葬費用給付寵物意外喪葬費用保險金。 ※ 保險期間內賠償金額最高以保險單首頁上所載的「寵物意外喪葬費用保險金額」為限。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險（最高給付1次）',
                        items:[{
                          title:'保期內最高',
                          amount:'8,000',
                          desc:'被保險寵物遺失時，自發現遺失30 日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付寵物協尋廣告費用保險金。（不含因懸賞廣告給付之報酬） ※ 保險期間內給付以1 次事故為限，賠償金額以保險單首頁上所載的「寵物協尋廣告費用保險金額」為限。'
                        }]
                      },
                      {
                        type:'寵物侵權責任保險',
                        items:[{
                          title:'保期內最高',
                          amount:'100萬',
                          desc:'被保險人在保險期間內因被保險寵物之行為致第三人體傷、死亡或財物損害，依法 應負賠償責任而受賠償請求時，本公司對被保險人負賠償之責。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'富邦寵物險',
                        url:'https://ec.rockgp.com/PET/%E5%AF%8C%E9%82%A6%E7%94%A2%E7%89%A9%E5%AE%89%E5%BF%83%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA(%E8%A8%88%E7%95%AB%E4%BA%8C).pdf'
                      }]
                    },
                  {    
                    id:this.modal3,                
                    insuName:'兆豐產物 方案A',
                    premiums:'2150',                    
                    type:'投保年齡',
                    content:[{
                        title:'犬',
                        amount:'8週~9歲'
                        },
                        { title:'貓',
                        amount:'8週~11歲'}],
                    items:[{
                        type:'寵物醫療費用補償保險',
                        items:[{
                          title:'保期內最高',
                          amount:'1.5萬',
                          desc:'被保險寵物於本契約有效期間內因第三條約定之疾病或傷害，於登記合格之獸醫院內進行診療者，保險公司就被保險人實際所支出之醫療費用，給付寵物醫療費用補償保險金，但不包含交通費及看護費。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },                      
                      {
                        type:'寵物侵權責任保險(含民刑事責任抗辯及訴訟費用)',
                        items:[{
                          title:'保期內最高',
                          amount:'150萬',
                          desc:'被保險人在保險期間內因被保險寵物行為所致第三人體傷、死亡或財物之損害，依法應負賠償責任，而受賠償請求時，保險公司對被保險人負賠償之責。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'每一事故最高',
                          amount:'2,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付「寵物協尋廣告費用」保險金，但保險期間內以兩次事故為限。前項費用之給付不包含被保險人因懸賞廣告所給付之報酬。'
                        }]
                      },
                      {
                        type:'寵物寄宿日額費用保險(保期內以最高十日為限)',
                        items:[{
                          title:'每一事故每日最高',
                          amount:'2,000',
                          desc:'被保險人於本契約有效期間內，因疾病或遭受意外傷害事故，經登記合格的醫院診治必須住院者，因連續住院日數達三日以上（含入院與出院日），於住院期間無法照護被保險寵物，致寄託被保險寵物於登記合格獸醫院或合法設立之寵物業，保險公司就被保險人實際所支出寵物寄宿費用，依照本契約所約定保險金額內，給付「寵物寄宿日額費用」保險金，保險期間給付總日數，最高以十日為限。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物喪葬費用保險',
                        items:[{
                          title:'保期內最高',
                          amount:'5,000',
                          desc:'被保險人因被保險寵物於保險期間內，自保險單起保日第三十日起因其自身之疾病或遭受意外傷害事故致死，保險公司就被保險人實際支出之喪葬費用給付「寵物喪葬費用」保險金。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物遺失安置收容費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'保期內最高',
                          amount:'1,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之動物收容所管理費，給付「寵物遺失安置收容費用」保險金，但保險期間內以兩次事故為限。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'兆豐產物寵物綜合保險乙式',
                        url:'https://ec.rockgp.com/PET/%E5%85%86%E8%B1%90%E7%94%A2%E7%89%A9%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA%E4%B9%99%E5%BC%8F%E4%BF%9D%E5%96%AE%E6%A2%9D%E6%AC%BE110.05.21.pdf'
                      }]
                   },
                  {    
                    id:this.modal4,                
                    insuName:'兆豐產物 方案B',
                    premiums:'3015',
                    type:'投保年齡',
                    content:[{
                        title:'犬',
                        amount:'8週~9歲'
                        },
                        { title:'貓',
                        amount:'8週~11歲'
                        }],
                    items:[{
                        type:'寵物醫療費用補償保險',
                        items:[{
                          title:'保期內最高',
                          amount:'3萬',
                          desc:'被保險寵物於本契約有效期間內因第三條約定之疾病或傷害，於登記合格之獸醫院內進行診療者，保險公司就被保險人實際所支出之醫療費用，給付寵物醫療費用補償保險金，但不包含交通費及看護費。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },                      
                      {
                        type:'寵物侵權責任保險(含民刑事責任抗辯及訴訟費用)',
                        items:[{
                          title:'保期內最高',
                          amount:'150萬',
                          desc:'被保險人在保險期間內因被保險寵物行為所致第三人體傷、死亡或財物之損害，依法應負賠償責任，而受賠償請求時，保險公司對被保險人負賠償之責。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'每一事故最高',
                          amount:'2,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付「寵物協尋廣告費用」保險金，但保險期間內以兩次事故為限。前項費用之給付不包含被保險人因懸賞廣告所給付之報酬。'
                        }]
                      },
                      {
                        type:'寵物寄宿日額費用保險(保期內以最高十日為限)',
                        items:[{
                          title:'每一事故每日最高',
                          amount:'2,000',
                          desc:'被保險人於本契約有效期間內，因疾病或遭受意外傷害事故，經登記合格的醫院診治必須住院者，因連續住院日數達三日以上（含入院與出院日），於住院期間無法照護被保險寵物，致寄託被保險寵物於登記合格獸醫院或合法設立之寵物業，保險公司就被保險人實際所支出寵物寄宿費用，依照本契約所約定保險金額內，給付「寵物寄宿日額費用」保險金，保險期間給付總日數，最高以十日為限。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物喪葬費用保險',
                        items:[{
                          title:'保期內最高',
                          amount:'5,000',
                          desc:'被保險人因被保險寵物於保險期間內，自保險單起保日第三十日起因其自身之疾病或遭受意外傷害事故致死，保險公司就被保險人實際支出之喪葬費用給付「寵物喪葬費用」保險金。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物遺失安置收容費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'保期內最高',
                          amount:'1,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之動物收容所管理費，給付「寵物遺失安置收容費用」保險金，但保險期間內以兩次事故為限。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'兆豐產物寵物綜合保險乙式',
                        url:'https://ec.rockgp.com/PET/%E5%85%86%E8%B1%90%E7%94%A2%E7%89%A9%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA%E4%B9%99%E5%BC%8F%E4%BF%9D%E5%96%AE%E6%A2%9D%E6%AC%BE110.05.21.pdf'
                      }]
                   },
                  { 
                    id:this.modal5,                   
                    insuName:'兆豐產物 方案C',
                    premiums:'3977',                  
                    type:'投保年齡',
                    content:[{
                       title:'犬',
                      amount:'8週~9歲'
                      },
                      { title:'貓',
                      amount:'8週~11歲'}],
                   items:[{
                        type:'寵物醫療費用補償保險',
                        items:[{
                          title:'保期內最高',
                          amount:'5萬',
                          desc:'被保險寵物於本契約有效期間內因第三條約定之疾病或傷害，於登記合格之獸醫院內進行診療者，保險公司就被保險人實際所支出之醫療費用，給付寵物醫療費用補償保險金，但不包含交通費及看護費。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },                      
                      {
                        type:'寵物侵權責任保險(含民刑事責任抗辯及訴訟費用)',
                        items:[{
                          title:'保期內最高',
                          amount:'150萬',
                          desc:'被保險人在保險期間內因被保險寵物行為所致第三人體傷、死亡或財物之損害，依法應負賠償責任，而受賠償請求時，保險公司對被保險人負賠償之責。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'每一事故最高',
                          amount:'2,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付「寵物協尋廣告費用」保險金，但保險期間內以兩次事故為限。前項費用之給付不包含被保險人因懸賞廣告所給付之報酬。'
                        }]
                      },
                      {
                        type:'寵物寄宿日額費用保險(保期內以最高十日為限)',
                        items:[{
                          title:'每一事故每日最高',
                          amount:'2,000',
                          desc:'被保險人於本契約有效期間內，因疾病或遭受意外傷害事故，經登記合格的醫院診治必須住院者，因連續住院日數達三日以上（含入院與出院日），於住院期間無法照護被保險寵物，致寄託被保險寵物於登記合格獸醫院或合法設立之寵物業，保險公司就被保險人實際所支出寵物寄宿費用，依照本契約所約定保險金額內，給付「寵物寄宿日額費用」保險金，保險期間給付總日數，最高以十日為限。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物喪葬費用保險',
                        items:[{
                          title:'保期內最高',
                          amount:'5,000',
                          desc:'被保險人因被保險寵物於保險期間內，自保險單起保日第三十日起因其自身之疾病或遭受意外傷害事故致死，保險公司就被保險人實際支出之喪葬費用給付「寵物喪葬費用」保險金。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物遺失安置收容費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'保期內最高',
                          amount:'1,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之動物收容所管理費，給付「寵物遺失安置收容費用」保險金，但保險期間內以兩次事故為限。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'兆豐產物寵物綜合保險乙式',
                        url:'https://ec.rockgp.com/PET/%E5%85%86%E8%B1%90%E7%94%A2%E7%89%A9%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA%E4%B9%99%E5%BC%8F%E4%BF%9D%E5%96%AE%E6%A2%9D%E6%AC%BE110.05.21.pdf'
                      }]
                   },
                  {   
                    id:this.modal6,                
                    insuName:'兆豐產物 方案D',
                    premiums:'5180',                    
                    type:'投保年齡',
                    content:[
                      {
                      title:'犬',
                      amount:'8週~9歲'
                      },
                      {
                      title:'貓',
                      amount:'8週~11歲'
                      }],
                    items:[{
                        type:'寵物醫療費用補償保險',
                        items:[{
                          title:'保期內最高',
                          amount:'7.5萬',
                          desc:'被保險寵物於本契約有效期間內因第三條約定之疾病或傷害，於登記合格之獸醫院內進行診療者，保險公司就被保險人實際所支出之醫療費用，給付寵物醫療費用補償保險金，但不包含交通費及看護費。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },                      
                      {
                        type:'寵物侵權責任保險(含民刑事責任抗辯及訴訟費用)',
                        items:[{
                          title:'保期內最高',
                          amount:'150萬',
                          desc:'被保險人在保險期間內因被保險寵物行為所致第三人體傷、死亡或財物之損害，依法應負賠償責任，而受賠償請求時，保險公司對被保險人負賠償之責。'
                        }]
                      },
                      {
                        type:'寵物協尋廣告費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'每一事故最高',
                          amount:'2,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之媒體或印刷品等協尋廣告費用，給付「寵物協尋廣告費用」保險金，但保險期間內以兩次事故為限。前項費用之給付不包含被保險人因懸賞廣告所給付之報酬。'
                        }]
                      },
                      {
                        type:'寵物寄宿日額費用保險(保期內以最高十日為限)',
                        items:[{
                          title:'每一事故每日最高',
                          amount:'2,000',
                          desc:'被保險人於本契約有效期間內，因疾病或遭受意外傷害事故，經登記合格的醫院診治必須住院者，因連續住院日數達三日以上（含入院與出院日），於住院期間無法照護被保險寵物，致寄託被保險寵物於登記合格獸醫院或合法設立之寵物業，保險公司就被保險人實際所支出寵物寄宿費用，依照本契約所約定保險金額內，給付「寵物寄宿日額費用」保險金，保險期間給付總日數，最高以十日為限。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物喪葬費用保險',
                        items:[{
                          title:'保期內最高',
                          amount:'5,000',
                          desc:'被保險人因被保險寵物於保險期間內，自保險單起保日第三十日起因其自身之疾病或遭受意外傷害事故致死，保險公司就被保險人實際支出之喪葬費用給付「寵物喪葬費用」保險金。 ※疾病：指被保險寵物或被保險人自本契約生效日起持續有效三十日（癌症為九十日）或續保日以後所發生之疾病。 ※傷害：指被保險寵物於本契約有效期間內，遭受意外傷害事故，因而蒙受之傷害。'
                        }]
                      },
                      {
                        type:'寵物遺失安置收容費用保險(保期內以兩次事故為限)',
                        items:[{
                          title:'保期內最高',
                          amount:'1,000',
                          desc:'被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之動物收容所管理費，給付「寵物遺失安置收容費用」保險金，但保險期間內以兩次事故為限。'
                        }]
                      }],
                      prodPolicies:[{
                        title:'兆豐產物寵物綜合保險乙式',
                        url:'https://ec.rockgp.com/PET/%E5%85%86%E8%B1%90%E7%94%A2%E7%89%A9%E5%AF%B5%E7%89%A9%E7%B6%9C%E5%90%88%E4%BF%9D%E9%9A%AA%E4%B9%99%E5%BC%8F%E4%BF%9D%E5%96%AE%E6%A2%9D%E6%AC%BE110.05.21.pdf'
                      }]
                   }
                   ]              

            }
          }
       }
      }     
    ,
    methods: {
      showModal(modalNo) {
        
       
       // this.$emit('input', val);
      },
    }   
  }
  </script>